import Repository from '../../repositories/RepositoryFactory';

const TabletsRepository = Repository.get('tablets');

export default {
	namespaced: true,
	state: {
		tablets: [],
	},
	mutations: {
		GET_TABLETS (state, payload) {
			state.tablets = payload;
		},
	},
	actions: {
		async getTablets ({ commit }) {
			commit('GET_TABLETS', await TabletsRepository.getTablets());
		},

	},
	getters: {},
};
